import { Col, Row } from 'antd';
import type { KpiValue, OverviewResponse } from '../contract';
import {
  NO_COMPARE_TEXT,
  NO_PREV_TEXT,
  compareCreatorsNote,
  fmtKc,
  fmtNum,
  fmtShare,
} from '../format';
import KpiCard from './kpi-card';
import styles from '../style.module.scss';
import more from '../style-more.module.scss';

/** Props so sánh chung cho một KPI tổng quan: nguồn theo `compareMode`, câu nguồn + "trên N Creator" của
 *  `ov.compare` khi cùng chế độ. Không có % → `compareNote` của backend (vì sao chưa so được); chỉ số không
 *  bao giờ có số tháng trước (`noPrev`: Fan mới) → "Không có số tháng trước". */
export function kpiCompareProps(
  kpi: Pick<KpiValue, 'pct' | 'prevN' | 'compareMode'>,
  ov: OverviewResponse,
  noPrev = false
) {
  const same = !!ov.compare && !!kpi.compareMode && kpi.compareMode === ov.compare.mode;
  const empty = noPrev
    ? NO_PREV_TEXT
    : !ov.compare
    ? ov.compareNote || NO_COMPARE_TEXT
    : !kpi.compareMode
    ? NO_PREV_TEXT
    : null;
  return {
    pct: kpi.pct,
    prevN: kpi.prevN,
    mode: kpi.compareMode ?? null,
    source: same ? ov.compare?.label : null,
    note: same ? compareCreatorsNote(ov.compare?.creators, ov.scope.creators) : null,
    empty,
  };
}

/** Hàng "Chỉ số phụ": Follower mới · Fan mới · Phiên LIVE · KC PK % (đặc tả 04 §5). */
const MoreKpis = ({ ov }: { ov: OverviewResponse }) => {
  const m = ov.moreKpis;
  if (!m) return null;
  const pk = m.pkDiamonds;
  return (
    <section aria-label="Chỉ số phụ" className={styles.section}>
      <h2 className={more.rowTitle}>Chỉ số phụ</h2>
      <Row gutter={[16, 16]}>
        <Col xs={24} sm={12} lg={6}>
          <KpiCard
            label="Follower mới"
            value={fmtNum(m.newFollowers.value)}
            series={m.newFollowers.series}
            color="#1F5FA8"
            {...kpiCompareProps(m.newFollowers, ov)}
          />
        </Col>
        <Col xs={24} sm={12} lg={6}>
          <KpiCard
            label="Fan mới"
            value={fmtNum(m.newFans.value)}
            series={m.newFans.series}
            color="#B98AF0"
            {...kpiCompareProps(m.newFans, ov, true)}
          />
        </Col>
        <Col xs={24} sm={12} lg={6}>
          <KpiCard
            label="Phiên LIVE"
            value={fmtNum(m.liveSessions.value)}
            series={m.liveSessions.series}
            color="#0F7A46"
            {...kpiCompareProps(m.liveSessions, ov)}
          />
        </Col>
        <Col xs={24} sm={12} lg={6}>
          <KpiCard
            label="KC từ trận PK"
            value={fmtShare(pk.sharePct)}
            sub={`${fmtKc(pk.value)} KC trên tổng ${fmtKc(ov.kpis.diamonds.value)} KC`}
            series={pk.series}
            color="#E8B04B"
          />
        </Col>
      </Row>
    </section>
  );
};

export default MoreKpis;
